/*
   Column chart Module
*/
import cloneDeep from 'lodash/cloneDeep';
import columnChartConfigBuilder from './column-chart-config-builder';
import { columnTooltip, areaTooltip, lineTooltip } from '../../widget-utilities/widget-tooltip';
import d3Utils from '../../../../utils/d3Utils';
import trendLines from '../../../../utils/trendLines';
import chartUtils from '../../../../utils/chart-utils';
var columnChart = function columnChart() {

    // Render column chart widget
    var renderWidget = function renderWidget(widgetConfig) {
        var ContainerId = widgetConfig.ContainerId,
            Model = widgetConfig.Model,
            Width = widgetConfig.Width,
            Height = widgetConfig.Height,
            FontWidth = widgetConfig.FontWidth,
            FontHeight = widgetConfig.FontHeight,
            Cloud = widgetConfig.Cloud,
            StampText = widgetConfig.StampText,
            ColorScheme = widgetConfig.ColorScheme,
            SortData = widgetConfig.SortData,
            Data = widgetConfig.Data,
            ChartConfig = widgetConfig.ChartConfig;


        var parentContainerId = ContainerId.includes('flip-') ? ContainerId.split('flip-')[1] : ContainerId;

        var el = window.document.querySelector('#' + ContainerId);

        d3.select(el).select('svg').remove();
        d3.select(el).select('.legend-table').remove();

        var modelName = Model;

        var margin = { top: 0.01, right: 0.02, bottom: 0.01, left: 0.02 },
            width = Number(chartUtils.replaceAll(Width, '\x01', "")),
            height = Number(chartUtils.replaceAll(Height, '\x01', "")),
            fontWidth = Number(FontWidth),
            fontHeight = Number(FontHeight);

        var hPadding = 0.02;
        var vPadding = 0.1;

        var xFieldName = ChartConfig.XAxisField;
        var yFieldName = ChartConfig.YAxisFields[0];
        var yFieldNames = ChartConfig.FormattedYFields;
        var CrumbFieldConfig = ChartConfig.CrumbFieldConfig;
        var crumbFieldName = CrumbFieldConfig[Object.keys(CrumbFieldConfig)[0]];
        var crumbDisplayFieldName = ChartConfig.CrumbDisplayFieldName;
        var baseCrumbtFormat = {
            'CloudName': Cloud,
            'ModelName': modelName,
            'Type': 'Node',
            'Name': Object.keys(CrumbFieldConfig)[0],
            'FieldName': crumbFieldName,
            'Value': '',
            'DisplayFieldName': crumbDisplayFieldName,
            'DisplayValue': null
        };
        var xAxisText = ChartConfig.XAxisName;
        var yAxisText = ChartConfig.YAxisNames[0];

        var defaultPerspective = ChartConfig.DefaultPerspective;

        var displayFormatPrimaryAxis = ChartConfig.ValueFormat;
        var currencySymbolPrimaryAxis = ChartConfig.CurrencySymbol;
        var baseFormatPrimaryAxis = ChartConfig.BaseFormat;
        var rotationAngle = Number(ChartConfig.RotationAngle);
        var includeTotal = ChartConfig.IncludeTotal;
        var includeTotalLine = ChartConfig.IncludeTotalLine;
        var inverseSort = ChartConfig.InverseSort;
        var showDataLegend = ChartConfig.ShowDataLegend;
        var xAxisDateFormat = ChartConfig.CategoryDateFormat;
        var classifierField = ChartConfig.ClassifierField;
        var stampText = StampText;
        var showLegend = ChartConfig.ShowLegend;
        var sortAxis = ChartConfig.SortAxis;
        var hideXAxis = ChartConfig.HideXAxis;
        var hideYAxis = ChartConfig.HideYAxis;
        var defaultRange = ChartConfig.DefaultRange;
        var xAxisTickValueField = ChartConfig.XAxisTickValueField;
        var seriesConfig = JSON.parse(chartUtils.replaceAll(JSON.stringify(ChartConfig.Series), '\x001', ""));
        var seriesData = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.seriesData), '\x001', ""));
        var seriesAccumulators = {};
        var maxValue = 0;
        var minValue = 0;
        var accumulator = [];
        var baseXValues = JSON.parse(chartUtils.replaceAll(JSON.stringify(ChartConfig.XAxisTickValues), '\x001', ""));
        var base = 'base';
        var negativeBase = 'negative-base';
        var barSeriesNames = [];
        var sortData = JSON.parse(chartUtils.replaceAll(JSON.stringify(SortData), '\x01', ""));
        var sortKeyName = ChartConfig.SortMatchPropertyName;
        var sortValueName = ChartConfig.SortValuePropertyName;
        var legendLineCount = Number(ChartConfig.LegendLineCount);
        var gridLines = Number(chartUtils.chartGridLine[widgetConfig.ChartConfig.GridLines.toLowerCase()]);
        var legendLocation = ChartConfig.LegendLocation;
        var maxLabelLength = 0;
        var maxValueLength = 0;
        var isDecimalPercentNumber = false;
        var maxBarWidth = 0.2;
        var colorScheme = JSON.parse(chartUtils.replaceAll(JSON.stringify(ColorScheme), '\x01', ""));
        var colorPalette = JSON.parse(chartUtils.replaceAll(JSON.stringify(ChartConfig.ColorPalette), '\x01', ""));
        var SecondaryAxisLabel = ChartConfig.SecondaryAxisLabel;
        var transitionEase = "linear";

        if (includeTotal.toString().toLocaleLowerCase() != "true" && includeTotal.toString().toLocaleLowerCase() != "false") includeTotal = false;

        if (includeTotalLine.toString().toLocaleLowerCase() != "true" && includeTotalLine.toString().toLocaleLowerCase() != "false") includeTotalLine = false;

        if (inverseSort.toString().toLocaleLowerCase() != "true" && inverseSort.toString().toLocaleLowerCase() != "false") inverseSort = false;

        if (showDataLegend.toString().toLocaleLowerCase() != "true" && showDataLegend.toString().toLocaleLowerCase() != "false") showDataLegend = false;

        if (xAxisDateFormat == "") xAxisDateFormat = null;

        var tempWidth = width - margin.left * width - margin.right * width;
        var tempHeight = height - margin.top * height - margin.bottom * height;
        var lineMarkerSize = 0.05 * Math.max(tempHeight, tempWidth);
        var barMaxWidth = 0.1 * tempWidth;

        var legendTableWidth = 0;
        var legendTableHeight = 0;

        if (showDataLegend) {
            //Assign 70% of the total size to the chart.
            height = height * 0.7 - margin.top;
            legendTableHeight = height * 0.3 - margin.bottom;
            legendTableWidth = width;
        }

        var legendScale = Math.min(tempWidth, tempHeight);
        var legendRectSize = 0.04;
        var legendVerticalPad = 0.08;
        var legendSpacing = 0.004;
        var legendWidth = 0.1;
        var offset = 0.005;

        var yAxisTickSpacing = Number(ChartConfig.YAxisTickSpacing);
        var xAxisTickSpacing = Number(ChartConfig.XAxisTickSpacing);

        var yAxisLabelSize = 0.05;
        var xAxisLabelSize = 0.04;
        var textOffset = "0";

        var tickCount = Number(ChartConfig.TickCount);
        var displayCount = Number(ChartConfig.DisplayCount);

        if (isNaN(xAxisTickSpacing)) xAxisTickSpacing = 0;

        if (Number(xAxisTickSpacing) >= 1) xAxisTickSpacing = Number(xAxisTickSpacing) / 100;

        if (isNaN(yAxisTickSpacing)) yAxisTickSpacing = 0;

        if (Number(yAxisTickSpacing) >= 1) yAxisTickSpacing = Number(yAxisTickSpacing) / 100;

        if (tickCount == 0) tickCount = 10;

        if (sortKeyName != null && sortKeyName.trim().length == 0) sortKeyName = null;

        if (sortValueName != null && sortValueName.trim().length == 0) sortValueName = null;

        if (yAxisText == "") yAxisLabelSize = 0;

        if (xAxisText == "") xAxisLabelSize = 0;

        var x = d3.scale.ordinal();

        var x1 = d3.scale.ordinal();

        var y = d3.scale.linear();

        var yFieldName2 = null;
        var y2 = null;
        var yAxis2 = null;
        var yAxisName2 = null;
        var defaultScale = "DefaultScale";
        var isNegative = false;
        var secondaryAxisTickCount = tickCount;

        if (yFieldNames.length == 2) yFieldName2 = yFieldNames[1];

        var seriesColor = d3.scale.category20();
        var processed = {};

        if (colorPalette != null && colorPalette.length > 0) seriesColor = d3.scale.ordinal().range(colorPalette);else if (colorScheme != null && colorScheme.length > 0) seriesColor = d3.scale.ordinal().range(colorScheme);

        if (!defaultRange) minValue = Number.POSITIVE_INFINITY;

        var sortAccumulator = {};

        if (sortData != null) {
            for (var i = 0; i < sortData.length; i++) {
                var d = sortData[i];

                if (d[sortKeyName] == null || d[sortValueName] == null) continue;

                if (sortAccumulator[d[sortKeyName]] == null) {
                    sortAccumulator[d[sortKeyName]] = Number(d[sortValueName]);

                    continue;
                }

                sortAccumulator[d[sortKeyName]] = sortAccumulator[d[sortKeyName]] + Number(d[sortValueName]);
            }
        }

        if (seriesConfig != null) {
            for (var index = 0; index < seriesConfig.length; index++) {

                var series = seriesConfig[index];

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                if (series.ClassName == null) series.ClassName = chartUtils.makeStyleName(seriesName);

                if (series.SeriesType != chartUtils.chartSeriesType.line && series.SeriesType != chartUtils.chartSeriesType.bar && series.SeriesType != chartUtils.chartSeriesType.area) continue;

                var seriesItemData = [];

                if (seriesData[series.SeriesName] != null) seriesItemData = JSON.parse(seriesData[series.SeriesName]);

                var tempAccumulator = [];

                for (var i = 0; i < seriesItemData.length; i++) {
                    var item = seriesItemData[i];

                    if (item[xFieldName] == null) continue;

                    if (isNaN(parseInt(item[xFieldName])) && item[xFieldName] != null && item[xFieldName].toString().trim().length == 0) continue;

                    //Format x axis ticks in the given date format
                    if (xAxisDateFormat != null) item[xFieldName] = chartUtils.formatDate(item[xFieldName], xAxisDateFormat);

                    if (xAxisTickValueField != null && xAxisTickValueField.trim().length > 0) {
                        var baseValueIndex = baseXValues.map(function (e) {
                            return e[xAxisTickValueField].toString().toLowerCase();
                        }).indexOf(item[xFieldName].toString().toLowerCase());

                        baseXValues[baseValueIndex][xFieldName] = item[xFieldName];

                        var tempArray = tempAccumulator.map(function (d) {
                            return d[xFieldName];
                        });

                        var tempIndex = -1;

                        if (tempArray.length > 0) tempIndex = tempArray.indexOf(item[xFieldName]);

                        if (tempIndex > -1) baseXValues[baseValueIndex][series.FieldName] = tempAccumulator[tempIndex][series.FieldName];else {
                            baseXValues[baseValueIndex][base] = 0;
                            baseXValues[baseValueIndex][series.FieldName] = 0;
                            baseXValues[baseValueIndex][negativeBase] = 0;
                        }

                        if (classifierField != null && item[classifierField] != null) baseXValues["className"] = chartUtils.makeStyleName(item[classifierField]);
                    } else {
                        var baseValue = chartUtils.findValue(baseXValues, xFieldName, item[xFieldName]);

                        if (baseValue == null) {
                            baseValue = {};
                            baseValue[xFieldName] = item[xFieldName];
                            baseValue[base] = 0;
                            baseValue[negativeBase] = 0;
                            baseValue[series.FieldName] = 0;

                            if (series.CrumbFieldName != null && series.CrumbFieldName.trim().length > 0) baseValue[series.CrumbFieldName] = item[series.CrumbFieldName];

                            if (series.CrumbDisplayFieldName != null && series.CrumbDisplayFieldName.trim().length > 0) baseValue[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

                            if (series.TipField != null && series.TipField.trim().length > 0) baseValue[series.TipField] = item[series.TipField];

                            if (classifierField != null && item[classifierField] != null) baseValue["className"] = chartUtils.makeStyleName(item[classifierField]);

                            if (series.Tooltip != null && series.Tooltip.TooltipConfigs != null && series.Tooltip.TooltipConfigs.length > 0) for (var tipIndex = 0; tipIndex < series.Tooltip.TooltipConfigs.length; tipIndex++) {
                                var tipItem = series.Tooltip.TooltipConfigs[tipIndex];

                                var tipValue = chartUtils.getTooltipValue(tipItem, item);

                                if (tipItem.TipField == series.FieldName && tipItem.AggregationType == "") tipValue = item[series.FieldName];

                                if (tipItem.TipField == series.crumbFieldName && tipItem.AggregationType == "") tipValue = item[series.crumbFieldName];

                                if (tipItem.TipField == series.CrumbDisplayFieldName && tipItem.AggregationType == "") tipValue = item[series.CrumbDisplayFieldName];

                                if (tipItem.TipField == series.FieldName && tipItem.AggregationType == "") tipValue = item[series.FieldName];

                                baseValue[tipItem.Id] = tipValue;
                            }

                            if (sortValueName != null && item[sortValueName] != null) baseValue[sortValueName] = item[sortValueName];

                            baseXValues.push(baseValue);
                        }
                    }

                    if (includeTotal) {
                        baseValue = chartUtils.findValue(baseXValues, xFieldName, "Total");

                        if (baseValue == null) {
                            if (index > 0) continue;

                            baseValue = {};
                            baseValue[xFieldName] = "Total";
                            baseValue[base] = 0;
                            baseValue[series.FieldName] = 0;
                            baseXValues.push(baseValue);
                        };
                    }

                    value = {};
                    value[xFieldName] = item[xFieldName];
                    value[series.CrumbFieldName] = item[series.CrumbFieldName];
                    value[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

                    if (series.TipField != null && series.TipField.trim().length > 0) value[series.TipField] = item[series.TipField];

                    if (classifierField != null && item[classifierField] != null) value["className"] = chartUtils.makeStyleName(item[classifierField]);
                    value[base] = 0;

                    if (series.SeriesType == chartUtils.chartSeriesType.bar) if (!chartUtils.inArray(barSeriesNames, series.SeriesName)) barSeriesNames.push(series.SeriesName);

                    // Handles the rendering of line for zero values for the chart
                    if (series.IgnoreBlanks) {
                        if (item[series.FieldName]) value[series.FieldName] = Number(item[series.FieldName]);else continue;
                    } else value[series.FieldName] = Number(item[series.FieldName]);

                    value["counter"] = item["RecordCount"];

                    if (series.Tooltip != null && series.Tooltip.TooltipConfigs != null && series.Tooltip.TooltipConfigs.length > 0) for (var tipIndex = 0; tipIndex < series.Tooltip.TooltipConfigs.length; tipIndex++) {
                        var tipItem = series.Tooltip.TooltipConfigs[tipIndex];

                        var tipValue = chartUtils.getTooltipValue(tipItem, item);

                        if (tipItem.TipField == series.FieldName && tipItem.AggregationType == "") tipValue = value[series.FieldName];

                        if (tipItem.TipField == series.crumbFieldName && tipItem.AggregationType == "") tipValue = item[series.crumbFieldName];

                        if (tipItem.TipField == series.CrumbDisplayFieldName && tipItem.AggregationType == "") tipValue = item[series.CrumbDisplayFieldName];

                        if (tipItem.TipField == series.FieldName && tipItem.AggregationType == "") tipValue = item[series.FieldName];

                        value[tipItem.Id] = tipValue;
                    }

                    tempAccumulator.push(value);

                    if (series.SeriesType == chartUtils.chartSeriesType.bar || series.SeriesType == chartUtils.chartSeriesType.area) {
                        if (xAxisTickValueField != "") baseXValues[baseValueIndex][base] = value[series.FieldName];else baseValue[base] = value[series.FieldName];
                    }
                    if (series.FormatConfig != null) {
                        for (var cf = 0; cf < series.FormatConfig.length; cf++) {
                            var format = series.FormatConfig[cf];
                            value[format.TableField] = item[format.TableField];
                            baseValue[format.TableField] = item[format.TableField];
                            value[format.TargetProperty] = item[format.TargetProperty];
                            baseValue[format.TargetProperty] = item[format.TargetProperty];
                        }
                    }

                    if (xAxisTickValueField != "") baseXValues[baseValueIndex][series.FieldName] = value[series.FieldName];else baseValue[series.FieldName] = value[series.FieldName];

                    if (value[series.FieldName] < 0) {
                        baseValue[base] = 0;
                        baseValue[negativeBase] = value[series.FieldName];
                    }
                };

                var tempMaxValue = d3.max(tempAccumulator, function (d) {
                    return Number(d[series.FieldName]);
                });

                var tempMinValue = d3.min(tempAccumulator, function (d) {
                    return Number(d[series.FieldName]);
                });

                tempMaxValue = isNaN(tempMaxValue) ? 0 : tempMaxValue;
                tempMinValue = isNaN(tempMinValue) ? 0 : tempMinValue;

                if (!series.PlotSecondaryAxis) {
                    maxValue = Math.max(maxValue, tempMaxValue);
                    minValue = Math.min(minValue, tempMinValue);
                }

                if (!series.IsTrendLine) sort(tempAccumulator);

                seriesAccumulators[seriesName] = tempAccumulator;

                if (series.SubSeries != null && series.SubSeries.length > 0) {
                    var baseSeries = series;
                    var baseSeriesName = chartUtils.replaceAll(baseSeries.SeriesName, " ", "");
                    if (!chartUtils.inArray(barSeriesNames, baseSeries.SeriesName)) barSeriesNames.push(baseSeries.SeriesName);

                    for (var index1 = 0; index1 < baseSeries.SubSeries.length; index1++) {
                        series = baseSeries.SubSeries[index1];

                        if (seriesData[series.SeriesName] == null) continue;

                        var seriesItemData = JSON.parse(seriesData[series.SeriesName]);

                        var tempAccumulator = [];

                        var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                        if (series.ClassName == null) series.ClassName = chartUtils.makeStyleName(seriesName);

                        for (var i = 0; i < seriesItemData.length; i++) {
                            var item = seriesItemData[i];

                            if (item[xFieldName] == null) continue;

                            if (item[xFieldName].toString().trim().length == 0) continue;

                            if (xAxisDateFormat != null) item[xFieldName] = chartUtils.formatDate(item[xFieldName], xAxisDateFormat);

                            var baseValue = chartUtils.findValue(baseXValues, xFieldName, item[xFieldName]);

                            if (xAxisTickValueField != "") {
                                var baseValueIndex = baseXValues.map(function (e) {
                                    return e[xAxisTickValueField].toString().toLowerCase();
                                }).indexOf(item[xFieldName].toString().toLowerCase());

                                if (!baseXValues[baseValueIndex][xFieldName]) {
                                    baseXValues[baseValueIndex][xFieldName] = item[xFieldName];
                                    baseXValues[baseValueIndex][base] = 0;
                                    baseXValues[baseValueIndex][series.FieldName] = 0;
                                    if (classifierField != null && item[classifierField] != null) baseXValues["className"] = chartUtils.makeStyleName(item[classifierField]);
                                }
                            } else {
                                baseValue = chartUtils.findValue(baseXValues, xFieldName, item[xFieldName]);
                                if (baseValue == null) {
                                    baseValue = {};
                                    baseValue[xFieldName] = item[xFieldName];
                                    baseValue[base] = 0;
                                    baseValue[series.FieldName] = 0;
                                    baseValue[negativeBase] = 0;

                                    if (series.CrumbFieldName != null && series.CrumbFieldName.trim().length > 0) baseValue[series.CrumbFieldName] = item[series.CrumbFieldName];

                                    if (series.CrumbDisplayFieldName != null && series.CrumbDisplayFieldName.trim().length > 0) baseValue[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

                                    if (series.TipField != null && series.TipField.trim().length > 0) baseValue[series.TipField] = item[series.TipField];

                                    if (classifierField != null && item[classifierField] != null) baseValue["className"] = chartUtils.makeStyleName(item[classifierField]);

                                    if (series.Tooltip != null && series.Tooltip.TooltipConfigs != null && series.Tooltip.TooltipConfigs.length > 0) for (var tipIndex = 0; tipIndex < series.Tooltip.TooltipConfigs.length; tipIndex++) {
                                        var tipItem = series.Tooltip.TooltipConfigs[tipIndex];

                                        var tipValue = chartUtils.getTooltipValue(tipItem, item);

                                        if (tipItem.TipField == series.FieldName) tipValue = value[series.FieldName];

                                        if (tipItem.TipField == series.crumbFieldName) tipValue = item[series.crumbFieldName];

                                        if (tipItem.TipField == series.CrumbDisplayFieldName) tipValue = item[series.CrumbDisplayFieldName];

                                        if (tipItem.TipField == series.FieldName) tipValue = item[series.FieldName];

                                        baseValue[tipItem.Id] = tipValue;
                                    }

                                    baseXValues.push(baseValue);
                                }
                            }

                            value = {};
                            value[xFieldName] = item[xFieldName];
                            value[series.CrumbFieldName] = item[series.CrumbFieldName];
                            value[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

                            if (series.TipField != null && series.TipField.trim().length > 0) baseValue[series.TipField] = item[series.TipField];

                            if (classifierField != null && item[classifierField] != null) value["className"] = chartUtils.makeStyleName(item[classifierField]);

                            value[series.FieldName] = Number(item[series.FieldName]);

                            value["counter"] = item["RecordCount"];

                            if (series.Tooltip != null && series.Tooltip.TooltipConfigs != null && series.Tooltip.TooltipConfigs.length > 0) for (var tipIndex = 0; tipIndex < series.Tooltip.TooltipConfigs.length; tipIndex++) {
                                var tipItem = series.Tooltip.TooltipConfigs[tipIndex];

                                var tipValue = chartUtils.getTooltipValue(tipItem, item);

                                if (tipItem.TipField == series.FieldName) tipValue = value[series.FieldName];

                                if (tipItem.TipField == series.crumbFieldName) tipValue = item[series.crumbFieldName];

                                if (tipItem.TipField == series.CrumbDisplayFieldName) tipValue = item[series.CrumbDisplayFieldName];

                                if (tipItem.TipField == yFieldName) tipValue = item[yFieldName];

                                value[tipItem.Id] = tipValue;
                            }

                            if (xAxisTickValueField != "") value[base] = baseXValues[baseValueIndex][base];else value[base] = baseValue[base];

                            value[negativeBase] = baseValue[negativeBase];

                            tempAccumulator.push(value);

                            if (xAxisTickValueField != "") baseXValues[baseValueIndex][base] = value[base] + value[series.FieldName];else {
                                if (value[series.FieldName] < 0) {
                                    baseValue[negativeBase] = value[negativeBase] + value[series.FieldName];
                                    baseValue[baseSeriesName + negativeBase] = baseValue[negativeBase];
                                } else {
                                    baseValue[base] = value[base] + value[series.FieldName];
                                    baseValue[baseSeriesName + base] = baseValue[base];
                                }
                            }
                        };

                        var tempMaxValue = d3.max(tempAccumulator, function (d) {
                            return Number(d[series.FieldName]) + Number(d[base]);
                        });

                        var tempMinValue = d3.min(tempAccumulator, function (d) {
                            return Number(d[series.FieldName]) + Number(d[base]);
                        });

                        if (!series.PlotSecondaryAxis) {
                            maxValue = Math.max(maxValue, tempMaxValue);
                            minValue = Math.min(minValue, tempMinValue);
                        }

                        seriesAccumulators[seriesName] = tempAccumulator;
                    };
                };
            };
        };

        if (seriesConfig != null && seriesConfig.length > 1 && typeof data != "undefined" && data != null) {
            var groups = chartUtils.getUnique(data, xFieldName);

            for (var i = 0; i < seriesConfig.length; i++) {
                var series = seriesConfig[i];

                if (series.PlotSecondaryAxis) continue;

                var acc = seriesAccumulators[series.SeriesName];

                if (acc == null || series.SeriesType == "Line") continue;

                if (groups != null) {
                    for (var index = 0; index < groups.length; index++) {
                        var value = chartUtils.findValue(acc, xFieldName, groups[index]);

                        if (value != null) continue;

                        value = {};
                        value[xFieldName] = groups[index];
                        value[series.FieldName] = 0;
                        value[base] = 0;
                        acc.push(value);
                    }
                }

                if (!includeTotal && !includeTotalLine) continue;

                var total = {};
                total[xFieldName] = "Total";

                var sum = 0;
                for (var j = 0; j < acc.length; j++) {
                    sum += Number(acc[j][series.FieldName]);
                }total[base] = 0;
                total[series.FieldName] = sum;

                acc.push(total);

                if (!includeTotalLine) continue;

                var tempMaxValue = d3.max(acc, function (d) {
                    return Number(d[series.FieldName]) + Number(d[base]);
                });

                maxValue = Math.max(maxValue, tempMaxValue);

                var tempMinValue = d3.min(acc, function (d) {
                    return Number(d[series.FieldName]) + Number(d[base]);
                });

                minValue = Math.min(minValue, tempMinValue);
            }
        }

        if (includeTotalLine && seriesAccumulators["Total"] != null) {
            var totalSeries = null;
            for (var index = 0; index < seriesConfig.length; index++) {
                if (seriesConfig[index].SeriesName.toLowerCase() != "total") continue;

                totalSeries = seriesConfig[index];
                break;
            }

            var totalAcc = seriesAccumulators["Total"];
            maxValue = 0;

            for (var index = 0; index < totalAcc.length; index++) {
                if (totalAcc[index][xFieldName] == "Total") continue;

                maxValue = Math.max(maxValue, totalAcc[index][totalSeries.FieldName]);
            }
        }

        if (defaultRange) maxValue += maxValue / 10;

        var range = maxValue - minValue;

        if (!defaultRange) {
            maxValue += range / 10;
            minValue -= range / 10;
        }

        var yAxis = d3.svg.axis().scale(y).orient('left').ticks(tickCount).tickFormat(function (d) {
            return chartUtils.format(d, displayFormatPrimaryAxis, currencySymbolPrimaryAxis, maxValue, baseFormatPrimaryAxis, isDecimalPercentNumber);
        });

        if (seriesConfig != null && seriesConfig.length > 0) {
            var maxYValue2 = 0;
            var minYValue2 = 0;

            for (var index = 0; index < seriesConfig.length; index++) {
                var series = seriesConfig[index];

                if (!series.PlotSecondaryAxis) continue;

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                yFieldName2 = series.FieldName;

                var displayFormatCurrent = getDisplayFormat(series);
                var currencySymbolCurrent = getCurrencySymbol(series);
                var baseFormatCurrent = getBaseFormat(series);
                if (series.SecondaryAxisTickCount > 0) secondaryAxisTickCount = Number(series.SecondaryAxisTickCount);

                var prefix = null;

                //Set default aggregation type as sum
                if (series.AggregationType == chartUtils.aggregationTypes.unknown) series.AggregationType = chartUtils.aggregationTypes.sum;

                if (series.AggregationType == chartUtils.aggregationTypes.sum) prefix = "Σ";

                if (series.AggregationType == chartUtils.aggregationTypes.count) prefix = "#";

                if (series.AggregationType == chartUtils.aggregationTypes.average) prefix = "⟨⟩";

                yAxisName2 = prefix + " " + series.SeriesName;

                var accumulator = seriesAccumulators[seriesName];

                for (var dataIndex = 0; dataIndex < accumulator.length; dataIndex++) {
                    maxYValue2 = Math.max(maxYValue2, accumulator[dataIndex][yFieldName2]);
                    minYValue2 = Math.min(minYValue2, accumulator[dataIndex][yFieldName2]);
                }
            }
        }

        if (yFieldName2 != null) {
            y2 = d3.scale.linear().rangeRound([height - legendRectSize - legendVerticalPad - xAxisTickSpacing, 0]);

            if (yFieldName2 == defaultScale) {
                maxYValue2 = 1;
                minYValue2 = 0;
            }

            maxYValue2 += maxYValue2 / 10;

            y2.domain([minYValue2, maxYValue2]);

            var interval = (maxYValue2 - minYValue2) / tickCount;

            yAxis2 = d3.svg.axis().scale(y2).orient('right').ticks(secondaryAxisTickCount).tickFormat(function (d) {
                return chartUtils.format(d, displayFormatCurrent, currencySymbolCurrent, maxYValue2, baseFormatCurrent, isDecimalPercentNumber);
            });
        }

        var xAxis = d3.svg.axis().scale(x).orient('bottom');

        function drawYAxisGrid() {
            return d3.svg.axis().scale(y).orient('left').ticks(tickCount);
        }

        function drawXAxisGrid() {
            return d3.svg.axis().scale(x).orient('bottom');
        }

        //Reset the series to the last primary axis series.
        for (var index = 0; index < seriesConfig.length; index++) {
            if (seriesConfig[index].PlotSecondaryAxis) continue;

            series = seriesConfig[index];
        }

        sort(baseXValues);

        var isNegativeAndPositive = false;
        var isNegativeSeries = false;
        var isPositiveSeries = false;
        var baseCounter = 0;
        var negativeBaseCounter = 0;

        //Checking if the series is completely negative/positive or a mix of both
        for (var baseIndex = 0; baseIndex < baseXValues.length; baseIndex++) {
            var baseXValue = baseXValues[baseIndex];

            if (!baseXValue.hasOwnProperty('base') && !baseXValue.hasOwnProperty('negative-base')) continue;

            if (baseXValue['base'] > 0) baseCounter += 1;

            if (baseXValue['negative-base'] < 0) negativeBaseCounter += 1;
        }

        if (baseCounter > 0 && negativeBaseCounter > 0) isNegativeAndPositive = true;else if (baseCounter === 0 && negativeBaseCounter > 0) isNegativeSeries = true;else if (baseCounter > 0 && negativeBaseCounter === 0) isPositiveSeries = true;

        //Logic to adjust spacing between value axis according to value labels
        if (baseXValues.length > 0) {
            var valueFormatLength = 0;
            var labelFactor = 0;
            var specialCharacterFactor = 0;
            var indexOfPeriod = 0;
            var considerDigitAfterDecimal = false;
            var calculatedWidth = width;
            var listOfSpecialCharacters = [',', '.', '(', ')', ':', '/'];

            if (isNegativeSeries) {
                valueFormatLength = minValue;
                labelFactor = 0.016;
                specialCharacterFactor = labelFactor / 2;
                considerDigitAfterDecimal = true;
                if (width > 1150) calculatedWidth = width * 0.5;
            } else if (isPositiveSeries && yAxisText !== "") {
                valueFormatLength = maxValue;
                labelFactor = -0.0125;
                specialCharacterFactor = -(labelFactor / 2);
            } else if (isNegativeAndPositive && yAxisText === "") {
                if (maxValue.toString().length >= minValue.toString().length) valueFormatLength = maxValue;else valueFormatLength = minValue;
                labelFactor = 0.0075;
                specialCharacterFactor = labelFactor / 2;
            } else calculatedWidth = 340; //to maintain ratio of 1 in case none of the above conditions are satisfied

            var specialCharacterCount = 0;
            var yAxisSpacing = 0;

            if (yAxisText !== "") yAxisSpacing = 0.05;

            var maxValueLabelSize = chartUtils.format(valueFormatLength, displayFormatPrimaryAxis, currencySymbolPrimaryAxis, valueFormatLength, baseFormatPrimaryAxis, false);

            if (considerDigitAfterDecimal) indexOfPeriod = maxValueLabelSize.indexOf('.');

            if (indexOfPeriod > 0) maxValueLabelSize = maxValueLabelSize.slice(0, indexOfPeriod + 1);

            var maxValueLabelSizeLength = maxValueLabelSize.length;

            for (var idx = 0; idx < maxValueLabelSizeLength; idx++) {
                if (listOfSpecialCharacters.includes(maxValueLabelSize[idx])) specialCharacterCount += 1;
            }

            yAxisLabelSize = yAxisSpacing + (maxValueLabelSizeLength - specialCharacterCount) * labelFactor + specialCharacterCount * specialCharacterFactor;
            if (width >= 410) yAxisLabelSize = yAxisLabelSize * (410 / calculatedWidth);
            if (width < 410) yAxisLabelSize = yAxisLabelSize * (calculatedWidth / 340);
        }

        if (displayCount > 0) {
            baseXValues = chartUtils.getTop(displayCount, baseXValues);
            for (var i = 0; i < seriesConfig.length; i++) {
                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');
                if (seriesAccumulators[seriesName] == null) continue;

                seriesAccumulators[seriesName] = chartUtils.getSubArray(seriesAccumulators[seriesName], baseXValues, xFieldName);
            }

            if (series.GroupOnField == null && seriesConfig.length <= 1) {
                var tempMaxValue = d3.max(baseXValues, function (d) {
                    return Number(d[base]);
                });

                maxValue = Math.max(maxValue, tempMaxValue);
            }

            for (var index = 0; index < baseXValues.length; index++) {
                if (baseXValues[index]["negative-base"] < 0) {
                    isNegative = true;
                    break;
                }
            }
        }

        if (baseSeries) {
            for (var currentSeries = 0; currentSeries < baseSeries["SubSeries"].length; currentSeries++) {
                var series = baseSeries["SubSeries"][currentSeries];

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                var currentSeriesAccumulator = seriesAccumulators[seriesName];

                if (currentSeriesAccumulator == null || currentSeriesAccumulator == 'undefined') continue;

                //if length of series accumulators is less than base series - add zeros for missing values
                if (currentSeriesAccumulator.length < baseXValues.length) {
                    for (var index = 0; index < baseXValues.length; index++) {
                        if (chartUtils.findValue(currentSeriesAccumulator, xFieldName, baseXValues[index][xFieldName]) == null) {
                            var value = {};

                            value[xFieldName] = baseXValues[index][xFieldName];

                            value[series.FieldName] = 0;

                            value[base] = 0;

                            currentSeriesAccumulator.push(value);
                        }
                    }
                }
            }
        }

        //Sort the series by baseXValues

        var _loop = function _loop() {

            var tempSeries = seriesConfig[index];

            var seriesName = tempSeries.SeriesName;

            var trendSeriesName = seriesName + " - Trend";

            seriesName = seriesName.replaceAll(' ', '');

            chartUtils.sortByBaseSeries(baseXValues, seriesAccumulators[seriesName], xFieldName);

            var tempAccumulator = seriesAccumulators[seriesName];

            if (trendLines.isSupported(ChartConfig.ChartType, tempSeries.SeriesType, ChartConfig.Series, tempAccumulator)) {

                var xName = null;

                if (tempSeries.SeriesType == chartUtils.chartSeriesType.scatterPlot) xName = tempSeries.XValueField;

                var coefficients = trendLines.computeLinearTrend(tempAccumulator, xName, tempSeries.FieldName);

                var slope = coefficients.slope;
                var intercept = coefficients.intercept;

                var tempData = tempAccumulator.map(function (d, index) {
                    var xValue = d[xFieldName];
                    var yValue = slope * (index + 1) + intercept;

                    var tempResult = {};
                    tempResult[xFieldName] = xValue;
                    tempResult[tempSeries.FieldName] = yValue;

                    return tempResult;
                });

                seriesAccumulators[trendSeriesName.replaceAll(' ', '')] = tempData;
            }
        };

        for (var index = 0; index < seriesConfig.length; index++) {
            _loop();
        }

        //Fill the line series with null for missing values
        for (var index = 0; index < seriesConfig.length; index++) {
            var series = seriesConfig[index];
            var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');
            var seriesType = series.SeriesType;

            if (seriesType != chartUtils.chartSeriesType.line) continue;

            var seriesData = seriesAccumulators[seriesName];
            var tempSeriesData = [];
            var tempBaseValues = chartUtils.getUnique(baseXValues, xFieldName);

            for (var i = 0; i < tempBaseValues.length; i++) {
                var item = tempBaseValues[i];
                var seriesItem = chartUtils.findValue(seriesData, xFieldName, item);
                if (seriesItem == null) {
                    tempSeriesData.push(null);
                    continue;
                }
                tempSeriesData.push(seriesItem);
            }

            seriesAccumulators[seriesName] = tempSeriesData;
        }

        x.domain(baseXValues.map(function (d) {
            var value = null;
            if (xAxisTickValueField != "") value = d[xAxisTickValueField];else value = d[xFieldName];

            maxLabelLength = Math.max(maxLabelLength, value.toString().length);
            return value;
        }));

        x1.domain(barSeriesNames).rangeRoundBands([0, x.rangeBand()]);

        //Compute X Axis Tick Spacing.
        xAxisTickSpacing = fontHeight / height + vPadding;
        if (Math.abs(rotationAngle) > 0) {
            xAxisTickSpacing = maxLabelLength * fontWidth * Math.sin(Math.PI * rotationAngle / 180) / height;
        }

        xAxisTickSpacing = xAxisTickSpacing > 0.25 ? 0.25 : xAxisTickSpacing;

        //Compute Y Axis Tick spacing
        var format = displayFormatPrimaryAxis == null ? ",.0f" : displayFormatPrimaryAxis;
        var formattedValue = chartUtils.format(maxValue, format, currencySymbolPrimaryAxis, maxValue, baseFormatPrimaryAxis, isDecimalPercentNumber);

        if (formattedValue != null) maxValueLength = formattedValue.toString().length - 1;

        yAxisTickSpacing = maxValueLength * fontWidth / width;

        var legendX = showLegend ? margin.left : 0;
        var legendY = showLegend ? margin.top : 0;
        var chartX = Number(margin.left) + Number(hPadding) + Number(yAxisTickSpacing) + Number(yAxisLabelSize);
        var chartY = !showLegend ? margin.top : margin.top + legendRectSize * legendLineCount + legendVerticalPad + legendSpacing * (legendLineCount - 1);

        chartY = isNaN(fontHeight) ? chartY : chartY + fontHeight / height;
        var chartWidth = 1 - chartX - margin.right;
        var chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing)) - chartY;
        var xAxisLabelY = Number(chartHeight) + Number(xAxisTickSpacing) + Number(vPadding);
        var labelX = margin.left;
        var bottomLegendSpace = 5;

        if (showLegend) {
            switch (legendLocation) {
                case chartUtils.legendLocation.right:
                    {
                        chartWidth = 1 - chartX - margin.right - Number(legendWidth) - Number(hPadding);
                        legendX = chartWidth + chartX + Number(hPadding);
                        chartY = margin.top;
                        chartY = isNaN(fontHeight) ? chartY : chartY + fontHeight / height;
                        chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing)) - chartY;
                        xAxisLabelY = Number(chartHeight) + Number(xAxisTickSpacing) + Number(vPadding);
                        break;
                    }
                case chartUtils.legendLocation.left:
                    {
                        chartWidth = 1 - chartX - margin.right - Number(legendWidth);
                        chartX += Number(legendWidth);
                        labelX = Number(chartX) - Number(yAxisLabelSize) - Number(yAxisTickSpacing);
                        chartY = margin.top;
                        chartY = isNaN(fontHeight) ? chartY : chartY + fontHeight / height;
                        chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing)) - chartY;
                        xAxisLabelY = Number(chartHeight) + Number(xAxisTickSpacing) + Number(vPadding);
                        break;
                    }
                case chartUtils.legendLocation.bottom:
                    {
                        chartY = Number(margin.top * bottomLegendSpace);
                        chartY = isNaN(fontHeight) ? chartY : chartY + fontHeight / height;
                        chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing) + Number(legendVerticalPad) + Number(legendRectSize)) - chartY;
                        xAxisLabelY = Number(chartHeight) + Number(xAxisTickSpacing) + Number(xAxisLabelSize) / 2 + Number(vPadding);
                        legendY = Number(xAxisLabelY) + Number(legendVerticalPad) + Number(xAxisLabelSize) + Number(legendRectSize) / 2;
                        break;
                    }
            }
        }

        var labelX2 = 0;

        if (yFieldName2 != null) {
            formattedValue = chartUtils.format(maxYValue2, series.SecondaryAxisValueFormat, series.SecondaryAxisCurrencySymbol, maxYValue2, series.SecondaryAxisBaseFormat, isDecimalPercentNumber);
            if (formattedValue != null) maxValueLength = formattedValue.length - 1;
            labelX2 = maxValueLength * fontWidth / width + Number(hPadding) + Number(yAxisLabelSize);
            chartWidth -= labelX2;
        }

        legendX = chartUtils.makeRelative(legendX, width);
        legendY = chartUtils.makeRelative(legendY, height);
        legendWidth = chartUtils.makeRelative(legendWidth, width);

        chartX = Number(chartUtils.makeRelative(chartX, width));
        chartY = Number(chartUtils.makeRelative(chartY, height));
        chartWidth = chartUtils.makeRelative(chartWidth, width);
        chartHeight = chartUtils.makeRelative(chartHeight + 0.01, height);
        xAxisLabelY = chartUtils.makeRelative(xAxisLabelY, height);
        labelX = chartUtils.makeRelative(labelX, width);
        textOffset = chartUtils.makeRelative(textOffset, width);
        maxBarWidth = chartUtils.makeRelative(maxBarWidth, width);

        var svg = d3.select(el).append('svg').attr('width', width).attr('height', height).attr('maxValue', maxValue).attr('minValue', minValue).attr('class', 'maximize-trigger').attr('viewBox', '0 0 ' + width + ' ' + height).attr('preserveAspectRatio', 'xMidYMid');

        var chartContainer = svg.append('g');
        // Added rect element to handle the events
        chartContainer.append('rect').attr('z-index', 1).attr('fill', 'none').attr('pointer-events', 'all');

        //Define axes range and domain
        var xPadding = 0.1;
        x.rangeBands([0, chartWidth], xPadding);
        x1.rangeRoundBands([0, x.rangeBand()]);

        if (x1.rangeBand() > maxBarWidth) {
            xPadding = 0.5;
            x.rangeBands([0, chartWidth], xPadding);
            x1.rangeRoundBands([0, x.rangeBand()]);
        }

        if (displayCount > 0 && !isNegative) y.range([chartHeight, 0]).domain([0, maxValue]).nice(tickCount);else y.range([chartHeight, 0]).domain([minValue, maxValue]).nice(tickCount);

        if (yFieldName2 != null) {
            y2 = d3.scale.linear().range([chartHeight, 0]);

            if (yFieldName2 == defaultScale) {
                maxYValue2 = 1;
                minYValue2 = 0;
            }

            maxYValue2 += maxYValue2 / 10;

            y2.domain([minYValue2, maxYValue2]).nice(secondaryAxisTickCount);

            yAxis2 = d3.svg.axis().scale(y2).orient('right').ticks(secondaryAxisTickCount).tickFormat(function (d) {
                return chartUtils.format(d, series.SecondaryAxisValueFormat, series.SecondaryAxisCurrencySymbol, maxYValue2, series.SecondaryAxisBaseFormat, isDecimalPercentNumber);
            });
        }

        var xAxis = d3.svg.axis().scale(x).orient('bottom');

        function drawYAxisGrid() {
            return d3.svg.axis().scale(y).orient('left').ticks(tickCount);
        }

        function drawXAxisGrid() {
            return d3.svg.axis().scale(x).orient('bottom');
        }

        var tempY = Number(chartY) + Number(chartHeight);

        chartContainer.append('g').attr('class', 'x axis').attr('transform', 'translate(' + chartX + ',' + tempY + ')').style('opacity', function () {
            if (hideXAxis) return 0;
            return 1;
        }).call(xAxis);

        var xAxisLabelContainer = chartContainer.append('g').append('text').attr('class', 'label x axis-label').attr('x', Number(chartWidth) / 2 + Number(chartX)).attr('y', Number(xAxisLabelY) + Number(chartY)).style('text-anchor', 'middle').text(xAxisText);

        if (!hideXAxis) {
            chartContainer.selectAll('.tick').select('text').style('text-anchor', function (d) {
                if (rotationAngle > 0) return 'end';
                return 'middle';
            }).attr('transform', function (d) {
                return 'rotate(-' + rotationAngle + ')';
            }).attr('class', function (d) {
                return 'dataviz';
            }).attr('coord', function (d, i) {
                var crumb = baseCrumbtFormat;
                crumb.DefaultPerspective = defaultPerspective;
                crumb.Value = d;
                var crumbValue = chartUtils.findValue(baseXValues, crumb.FieldName, d);
                if (crumbValue != null) crumb.DisplayValue = crumbValue[crumb.DisplayFieldName];
                return JSON.stringify(crumb);
            });
        }

        chartContainer.append('g').attr('class', 'y axis').attr('transform', 'translate(' + chartX + ',' + chartY + ')').style('opacity', function () {
            if (hideYAxis) return 0;
            return 1;
        }).call(yAxis);

        var yAxisLabelContainer = svg.append('g').append('text').attr('class', 'label y axis-label').attr('transform', 'rotate(-90)').attr('x', -1 * (chartHeight / 2 + chartY)).attr('y', labelX).attr('dy', '0.5em').style('text-anchor', 'middle').text(yAxisText);

        if (seriesConfig.length > 1) {
            if (gridLines == chartUtils.chartGridLine.both || gridLines == chartUtils.chartGridLine.xaxis) {
                // To put grid line at the end of the group
                var gridLinePadding = xPadding * chartWidth / baseXValues.length / 2;
                chartContainer.append('g').attr('transform', 'translate(' + (chartX + x.rangeBand() / 2 + gridLinePadding) + ',' + tempY + ')').attr('class', 'x axis-grid').call(drawXAxisGrid().tickSize(-chartHeight, 0, 0).tickFormat(""));
            }
        } else {
            if (gridLines == chartUtils.chartGridLine.both || gridLines == chartUtils.chartGridLine.xaxis) chartContainer.append('g').attr('transform', 'translate(' + chartX + ',' + tempY + ')').attr('class', 'x axis-grid').call(drawXAxisGrid().tickSize(-chartHeight, 0, 0).tickFormat(""));
        }

        if (gridLines == chartUtils.chartGridLine.both || gridLines == chartUtils.chartGridLine.yaxis) chartContainer.append('g').attr('class', 'y axis-grid').attr('transform', 'translate(' + chartX + ',' + chartY + ')').call(drawYAxisGrid().tickSize(-chartWidth, 0, 0).tickFormat(""));

        if (yFieldName2 != null) {
            chartContainer.append('g').attr('class', 'y y2 axis').attr('transform', 'translate(' + (chartX + Number(chartWidth)) + ',' + chartY + ')').call(yAxis2).append('text').attr('class', 'label y axis-label').attr('transform', 'rotate(-90)').attr('x', -1 * (chartHeight / 2)).attr('y', '4em').style('text-anchor', 'middle').text(SecondaryAxisLabel);
        }

        function getDisplayFormat(series) {
            var x = '';

            if ((series.ValueFormat != null || series.ValueFormat != undefined) && series.ValueFormat.trim().length > 0) {
                x = series.ValueFormat;
            } else {
                if (series.PlotSecondaryAxis) {
                    x = series.SecondaryAxisValueFormat;
                } else {
                    x = displayFormatPrimaryAxis;
                }
            }

            return x;
        }

        function getCurrencySymbol(series) {
            var x = '';

            if ((series.CurrencySymbol != null || series.CurrencySymbol != undefined) && series.CurrencySymbol.trim().length > 0) {
                x = series.CurrencySymbol;
            } else {
                if (series.PlotSecondaryAxis) {
                    x = series.SecondaryAxisCurrencySymbol;
                } else {
                    x = currencySymbolPrimaryAxis;
                }
            }

            return x;
        }

        function getBaseFormat(series) {
            var x = '';

            if ((series.BaseFormat != null || series.BaseFormat != undefined) && series.BaseFormat.trim().length > 0) {
                x = series.BaseFormat;
            } else {
                if (series.PlotSecondaryAxis) {
                    x = series.SecondaryAxisBaseFormat;
                } else {
                    x = baseFormatPrimaryAxis;
                }
            }

            return x;
        }

        // Get marker element closest to pointer position on entire area series
        function getMarkerElement() {

            function calculateDistance(element) {
                var markerX = element.getAttribute('xpos');
                var markerY = element.getAttribute('ypos');
                var distanceFromMarkerX = Math.abs(svgPoint.x - markerX);
                var xPos = distanceFromMarkerX * distanceFromMarkerX;
                var distanceFromMarkerY = Math.abs(svgPoint.y - markerY);
                var yPos = distanceFromMarkerY * distanceFromMarkerY;
                var distance = Math.sqrt(xPos + yPos);
                return distance;
            }

            var e = d3.event;
            var minDistanceFromMarker = 999999;
            // Get closest svg element
            var svg = this.closest('svg');

            // Translate pointer coordinates on screen to SVG coordinates

            var pt = svg.createSVGPoint();

            pt.x = e.clientX;
            pt.y = e.clientY;

            var svgPoint = pt.matrixTransform(svg.getScreenCTM().inverse());
            var allMarkerElements = d3.select(this.parentNode).selectAll('.dot');
            var markerElements = allMarkerElements[0].filter(function (item) {
                return !item.getAttribute("seriesidentifier").includes("Trend");
            });
            var markerElement = void 0;
            var markerElementsForSeries = void 0;
            // Checking whether it is area chart or line chart
            if (e.currentTarget.getAttribute('seriesidentifier')) {
                var seriesIdentifier = this.getAttribute('seriesidentifier').split('-')[1];

                // Checking if seriesIdentifier is undefined or empty string then replacing with '--'
                seriesIdentifier = seriesIdentifier && seriesIdentifier.length ? seriesIdentifier : '--';

                // Get all marker elements and filter for a particular series
                markerElementsForSeries = markerElements.filter(function (element) {
                    return element.getAttribute('seriesidentifier') === seriesIdentifier;
                });

                // Get marker element closest to pointer position on entire area series
                markerElement = markerElementsForSeries[0];
            } else {
                markerElement = markerElements[0];
                markerElementsForSeries = markerElements;
            }
            if (markerElement) {
                markerElementsForSeries.forEach(function (element) {
                    var distanceFromMarker = calculateDistance(element);
                    if (distanceFromMarker <= minDistanceFromMarker) {
                        minDistanceFromMarker = distanceFromMarker;
                        markerElement = element;
                    }
                });
            }
            return markerElement;
        }

        function showSeriesLabels(series) {
            if (series.SubSeries != null) {
                var data = displayCount > 0 ? chartUtils.getTop(displayCount, baseXValues) : baseXValues;
                baseSeriesName = chartUtils.replaceAll(series.SeriesName, " ", "");
            } else var data = displayCount > 0 ? chartUtils.getTop(displayCount, accumulator) : accumulator;

            var valueAxis = y;

            if (series.PlotSecondaryAxis) valueAxis = y2;

            var displayFormatCurrent = getDisplayFormat(series);
            var currencySymbolCurrent = getCurrencySymbol(series);
            var baseFormatCurrent = getBaseFormat(series);

            chartContainer.selectAll(".text").data(data.filter(function (d) {
                return d != null;
            })).enter().append("text").attr('transform', function (d, i) {
                var xPos = x(d[xFieldName]) + x.rangeBand() / 2 + chartX;

                if (series.SeriesType == chartUtils.chartSeriesType.bar) xPos = Number(x(d[xFieldName])) + Number(x1(series.SeriesName)) + x1.rangeBand() / 2 + chartX;
                var basePos = 12;
                if (Number(d[series.FieldName]) >= 0) basePos = -2;

                return 'translate(' + xPos + ',' + (valueAxis(series.SubSeries != null ? d[baseSeriesName + base] : d[series.FieldName]) + basePos + chartY) + ')';
            }).text(function (d) {
                return chartUtils.format(series.SubSeries != null ? Number(d[baseSeriesName + base]) : Number(d[series.FieldName]), displayFormatCurrent, currencySymbolCurrent, maxValue, baseFormatCurrent, isDecimalPercentNumber);
            }).attr('text-anchor', function (d) {
                if (series.SeriesType == chartUtils.chartSeriesType.bar) return 'middle';else return 'end';
            }).attr('class', function (d) {
                if (series.SeriesType == chartUtils.chartSeriesType.bar) return 'column-label';

                return 'line-point-label';
            }).attr('opacity', 0).transition().delay(500).duration(200).attr('opacity', 1);
        };

        var minOpacity = 0.5;

        if (seriesConfig != null) {
            var markerSeries = [];

            for (var index = 0; index < seriesConfig.length; index++) {
                var series = seriesConfig[index];
                if (series.SeriesType != chartUtils.chartSeriesType.area) continue;
                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');
                if (seriesAccumulators[seriesName] == null) continue;

                markerSeries.push(series);
                var accumulator = seriesAccumulators[seriesName];

                var area = d3.svg.area().x(function (d) {
                    return x(d[xFieldName]) + x.rangeBand() / 2 + chartX;
                }).y0(function (d) {
                    return y(d['base']) + chartY;
                }).y1(function (d) {
                    return y(d[series.FieldName] + d['base']) + chartY;
                });

                if (series.SmoothCurves) area = d3.svg.area().interpolate("cardinal").x(function (d) {
                    return x(d[xFieldName]) + x.rangeBand() / 2 + chartX;
                }).y0(function (d) {
                    return y(d['base']) + chartY;
                }).y1(function (d) {
                    return y(d[series.FieldName] + d['base']) + chartY;
                });

                chartContainer.append('path').on("touchstart", function () {
                    var markerElement = getMarkerElement.call(this);
                    markerElement && areaTooltip.onMouseOver.call(markerElement, parentContainerId);
                }).on("mouseover", function () {
                    var markerElement = getMarkerElement.call(this);
                    markerElement && areaTooltip.onMouseOver.call(markerElement, parentContainerId);
                }).on("mouseout", function () {
                    areaTooltip.onMouseOut();
                }).on("touchmove", function () {
                    areaTooltip.onMouseOut();
                }).on("mousemove", function () {
                    var markerElement = getMarkerElement.call(this);
                    markerElement && areaTooltip.onMouseMove.call(markerElement, parentContainerId);
                }).datum(accumulator).attr('class', 'area ' + chartUtils.makeStyleName(series.ClassName)).attr('seriesidentifier', function (d) {
                    return 'area-' + series.SeriesName;
                }).attr('stroke', '#000000').attr('d', area).style('fill', function (d) {
                    if (series.Color != null && series.Color.trim().length > 0) return series.Color;

                    return seriesColor(seriesName);
                }).attr('id', function (d, i) {
                    return 'area' + i;
                }).style('stroke-width', 0).style('fill-opacity', 0).transition().duration(500).delay(function (d, i) {
                    return i * 750;
                }).style('visibility', function (d) {
                    return series.Hidden ? "hidden" : "visible";
                }).style('stroke-width', 1).style('fill-opacity', function (d) {
                    var opacity = 1 - index * 0.1;
                    if (opacity < minOpacity) return minOpacity;
                    return opacity;
                });

                if (series.SubSeries != null && series.SubSeries.length > 0) {
                    var baseSeries = series;
                    for (var index1 = 0; index1 < baseSeries.SubSeries.length; index1++) {
                        series = baseSeries.SubSeries[index1];
                        if (series.SeriesType != chartUtils.chartSeriesType.area) continue;
                        var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');
                        if (seriesAccumulators[seriesName] == null) continue;

                        markerSeries.push(series);
                        var accumulator = seriesAccumulators[seriesName];

                        chartContainer.append('path').on("touchstart", function () {
                            var markerElement = getMarkerElement.call(this);
                            markerElement && areaTooltip.onMouseOver.call(markerElement, parentContainerId);
                        }).on("mouseover", function () {
                            var markerElement = getMarkerElement.call(this);
                            markerElement && areaTooltip.onMouseOver.call(markerElement, parentContainerId);
                        }).on("mouseout", function () {
                            areaTooltip.onMouseOut();
                        }).on("touchmove", function () {
                            areaTooltip.onMouseOut();
                        }).on("mousemove", function () {
                            var markerElement = getMarkerElement.call(this);
                            areaTooltip.onMouseMove.call(markerElement, parentContainerId);
                        }).datum(accumulator).attr('class', function (d) {
                            if (d["className"] == null) return 'area ' + series.ClassName;

                            return 'area ' + series.ClassName + ' ' + d["className"];
                        }).attr('seriesidentifier', function (d) {
                            return 'area-' + series.SeriesName;
                        }).attr('stroke', '#000000').attr('d', area).attr('id', function (d, i) {
                            return 'area' + i;
                        }).style('fill', function (d) {
                            if (series.Color != null && series.Color.trim().length > 0) return series.Color;

                            return seriesColor(seriesName);
                        }).style('stroke-width', 0).style('fill-opacity', 0).transition().duration(500).delay(function (d, i) {
                            return i * 750;
                        }).style('stroke-width', 1).style('fill-opacity', function (d) {
                            var opacity = 1 - index * 0.1;
                            if (opacity < minOpacity) return minOpacity;
                            return opacity;
                        });
                    }
                }
                continue;
            }

            for (var i = 0; i < markerSeries.length; i++) {
                showLineMarkers(markerSeries[i]);
                drawMarkerLines(markerSeries[i]);
            }
        }

        function showLineMarkers(series) {
            var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');
            var seriesType = series.SeriesType.toLowerCase();
            var data = seriesAccumulators[seriesName];
            chartContainer.selectAll(".dot" + seriesName).data(data.filter(function (d) {
                return d != null;
            })).enter().append("path").attr('transform', function (d) {
                return 'translate(' + (x(d[xFieldName]) + x.rangeBand() / 2 + chartX) + ',' + (y(d[series.FieldName] + d['base']) + chartY) + ')';
            }).attr('xpos', function (d) {
                return x(d[xFieldName]) + x.rangeBand() / 2 + chartX;
            }).attr('ypos', function (d) {
                return y(d[series.FieldName] + d['base']) + chartY;
            }).attr('seriesidentifier', series.SeriesName).attr('d', d3.svg.symbol().type('circle').size(lineMarkerSize)).attr('class', function (d) {
                if (d["className"] == null) return 'dot dataviz editviz ' + chartUtils.makeStyleName(seriesName) + ' ' + seriesType;
            }).style("fill", function (d) {
                var fillColor = seriesColor(seriesName);
                if (series.Color != null && series.Color.trim().length > 0) fillColor = series.Color;

                if (series.FormatConfig != null && series.FormatConfig.length > 0) {
                    var displaytext = d[series.FieldName];
                    var formatOption = getFormatOption(series, displaytext, d);
                    if (formatOption != null) {
                        fillColor = formatOption.Fill;
                        this.style.stroke = formatOption.BorderColor;
                        if (formatOption.Animate == true) {
                            this.attributes['class'].value = this.attributes['class'].value + ' animate';
                        }
                    }
                }
                return fillColor;
            }).style("stroke", function (d) {
                if (series.Color != null && series.Color.trim().length > 0) return series.Color;

                return seriesColor(seriesName);
            }).attr('label', function (d, i) {
                var displayFormatCurrent = getDisplayFormat(series);
                var currencySymbolCurrent = getCurrencySymbol(series);
                var baseFormatCurrent = getBaseFormat(series);

                var value = 0;

                if (d == null) return "--";

                value = Number(d[series.FieldName]);

                if (isNaN(value)) value = 0;

                var tipHeader = series.SeriesName;

                if (series.TipField != null && d[series.TipField] != null) tipHeader = d[series.TipField] + '<br/>' + tipHeader;

                if (series.ShowDefaultTooltip) {
                    var defaultTipText = '<span class="tip-header">' + tipHeader + ':</span><span class="tip-value"> ' + chartUtils.format(value, displayFormatCurrent, currencySymbolCurrent, maxValue, baseFormatCurrent, isDecimalPercentNumber) + '</span>';
                }

                var tooltip = series.Tooltip;

                var tipText = chartUtils.buildTooltipText(tooltip, d, defaultTipText, series.FieldName, series.AggregationType, series.TotalRecords);

                return tipText;
            }).attr('value', function (d) {
                return Number(d[series.FieldName]).toFixed(2);
            }).attr('id', function (d, i) {
                return 'Dot-' + seriesName + i;
            }).attr('coord', function (d, i) {
                var crumb = baseCrumbtFormat;
                crumb.Name = series.CrumbMetaName;
                crumb.FieldName = series.CrumbFieldName;
                crumb.Value = d[series.CrumbFieldName];
                crumb.DisplayFieldName = series.CrumbDisplayFieldName;
                crumb.DisplayValue = d[series.CrumbDisplayFieldName];
                crumb.DefaultPerspective = defaultPerspective;
                return JSON.stringify(crumb);
            }).attr('x', function (d) {
                return x(d[xFieldName]) + x.rangeBand() / 2;
            }).attr('y0', function (d) {
                return y(d['base']);
            }).attr('y1', function (d) {
                return y(d[series.FieldName] + d['base']);
            }).style('opacity', 0).on("touchstart", function () {
                areaTooltip.onMouseOver.call(this, parentContainerId, 'dot');
            }).on("mouseover", function () {
                areaTooltip.onMouseOver.call(this, parentContainerId, 'dot');
            }).on("mouseout", function () {
                areaTooltip.onMouseOut.call(this, 'dot');
            }).on("touchmove", function () {
                areaTooltip.onTouchMove.call(this, 'dot');
            }).on("mousemove", function () {
                areaTooltip.onMouseMove.call(this, parentContainerId, 'dot');
            });

            svg.selectAll(".animate").append("animate").attr('attributeType', "XML").attr('attributeName', 'opacity').attr('from', '0.6').attr('to', '0.3').attr('dur', '1s').attr('repeatCount', 'indefinite');
        }

        // Draw marker lines
        function drawMarkerLines(series) {
            var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');
            var data = seriesAccumulators[seriesName];
            var lineFunction = d3.svg.line().x(function (d) {
                return d.x;
            }).y(function (d) {
                return d.y;
            }).interpolate("linear");

            chartContainer.selectAll(".marker-line").data(data.filter(function (d) {
                return d != null;
            })).enter().append("path").attr("d", function (d) {
                var lineXCoord = x(d[xFieldName]) + x.rangeBand() / 2 + chartX;
                var lineCoords = [{ x: lineXCoord, y: chartY }, { x: lineXCoord, y: Number(chartY) + Number(chartHeight) }];
                return lineFunction(lineCoords);
            }).attr("id", function (d, i) {
                return 'line-' + seriesName.toLowerCase() + i;
            }).attr("stroke", "#cccccc").attr("seriesidentifier", 'markerline-' + seriesName.toLowerCase()).style("opacity", 0);
        }

        var group = chartContainer.selectAll('.group').data(baseXValues).enter().append('g').attr('z-index', 2).attr('transform', function (d) {
            if (d[xAxisTickValueField]) var xValue = d[xAxisTickValueField];else var xValue = d[xFieldName];

            return 'translate(' + (x(xValue) + chartX) + ',' + chartY + ')';
        }).attr('class', 'group').attr('id', function (d, i) {
            return 'group' + i;
        });

        // Defined to integrate animation for column and line widgets with d3 data
        var groupLengthCheck = group.length > 0 ? true : false;
        var svgInnerHeight = Number(svg.attr("innerHeight"));
        var getBaseAttribute = function getBaseAttribute(element) {
            return Number(d3.select(element).attr('base'));
        };
        var getStrokeTotalLength = function getStrokeTotalLength(element) {
            return d3.select(element).node().getTotalLength();
        };
        // Taking different types of series available for chart to apply the events
        var chartElements = ChartConfig.Series.filter(function (series) {
            return !series.IsTrendLine;
        });

        var chartElementsWithOutTrendLines = chartElements.map(function (series) {
            return series.SeriesType;
        });

        var chartSeriesTypeSet = new Set(chartElementsWithOutTrendLines);

        if (seriesConfig != null) {
            for (var index = 0; index < seriesConfig.length; index++) {
                var series = seriesConfig[index];

                var valueAxis = y;
                var minYValue = minValue;

                if (series.PlotSecondaryAxis) {
                    valueAxis = y2;
                    minYValue = minYValue2;
                }

                if (series.SeriesType != chartUtils.chartSeriesType.line && series.SeriesType != chartUtils.chartSeriesType.bar) continue;

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                if (seriesAccumulators[seriesName] == null) continue;

                var accumulator = seriesAccumulators[seriesName];

                if (series.SubSeries == null && series.ShowLabels) showSeriesLabels(series);

                var displayFormatCurrent = getDisplayFormat(series);
                var currencySymbolCurrent = getCurrencySymbol(series);
                var baseFormatCurrent = getBaseFormat(series);

                if (seriesName == "Total" && includeTotalLine) {
                    group.append('path').attr('d', function (d, i) {
                        var xPoint1 = 0;
                        var xPoint2 = xPoint1 + x.rangeBand();
                        var value = Number(accumulator[i][series.FieldName]);
                        var base = Number(accumulator[i]['base']);
                        var yPoint = y(value + base);
                        return "M " + xPoint1 + " " + yPoint + " H " + xPoint2;
                    }).attr('class', function (d) {
                        if (d["className"] == null) return 'total-line ' + series.ClassName;

                        return 'total-line ' + series.ClassName + ' ' + d["className"];
                    }).attr('label', function (d, i) {
                        var value = 0;

                        if (accumulator[i] == null) return "--";

                        value = Number(accumulator[i][series.FieldName]);

                        if (isNaN(value)) value = 0;

                        var tipHeader = series.StackOnField != null || series.GroupOnField != null ? series.FieldName : series.SeriesName;

                        if (series.TipField != null && d[series.TipField] != null) tipHeader = d[series.TipField] + '<br/>' + tipHeader;

                        if (series.ShowDefaultTooltip) {
                            var defaultTipText = '<span class="tip-header">' + tipHeader + ':</span><span class="tip-value"> ' + chartUtils.format(value, displayFormatCurrent, currencySymbolCurrent, maxValue, baseFormatCurrent, isDecimalPercentNumber) + '</span>';
                        }

                        var tooltip = series.Tooltip;

                        var tipText = chartUtils.buildTooltipText(tooltip, accumulator[i], defaultTipText, series.FieldName, series.AggregationType, series.TotalRecords);

                        return tipText;
                    }).attr('coord', function (d, i) {
                        var crumb = baseCrumbtFormat;
                        crumb.Name = series.CrumbMetaName;
                        crumb.FieldName = series.CrumbFieldName;
                        crumb.Value = accumulator[i][series.CrumbFieldName];
                        crumb.DisplayFieldName = series.CrumbDisplayFieldName;
                        crumb.DisplayValue = accumulator[i][series.CrumbDisplayFieldName];
                        crumb.DefaultPerspective = defaultPerspective;
                        return JSON.stringify(crumb);
                    }).style("fill", "none").style("stroke", "#000");

                    continue;
                }

                if (series.SeriesType == chartUtils.chartSeriesType.bar) {
                    group.append('rect').attr('class', function (d) {
                        if (d["className"] == null) return 'bar dataviz editviz ' + series.ClassName;

                        return 'bar dataviz editviz ' + series.ClassName + ' ' + d["className"];
                    }).style('fill', function (d) {
                        var fillColor = seriesColor(seriesName);
                        if (series.Color != null && series.Color.trim().length > 0) fillColor = series.Color;

                        if (series.FormatConfig != null && series.FormatConfig.length > 0) {
                            var displaytext = d[series.FieldName];
                            var formatOption = getFormatOption(series, displaytext, d);
                            if (formatOption != null) {
                                fillColor = formatOption.Fill;
                                this.style.stroke = formatOption.BorderColor;
                                if (formatOption.Animate == true) {
                                    this.attributes['class'].value = this.attributes['class'].value + ' animate';
                                }
                            }
                        }
                        return fillColor;
                    }).style('visibility', function (d) {
                        return series.Hidden ? "hidden" : "visible";
                    }).attr('x', x1(series.SeriesName)).attr('width', x1.rangeBand()).attr('label', function (d, i) {
                        var tipField = series.TipField == null || series.TipField.trim().length == 0 ? xFieldName : series.TipField;

                        var xValue = d[tipField];

                        var index = accumulator.map(function (e) {
                            return e[tipField];
                        }).indexOf(xValue);

                        if (index < 0) return;

                        var value = 0;

                        if (accumulator[index] == null) return "--";

                        value = Number(accumulator[index][series.FieldName]);

                        if (isNaN(value)) value = 0;

                        var tipHeader = series.SeriesName;

                        if (series.TipField != null && d[series.TipField] != null) tipHeader = d[series.TipField] + '<br/>' + tipHeader;

                        if (series.ShowDefaultTooltip) {
                            var defaultTipText = '<span class="tip-header">' + tipHeader + ':</span><span class="tip-value"> ' + chartUtils.format(value, displayFormatCurrent, currencySymbolCurrent, maxValue, baseFormatCurrent, isDecimalPercentNumber) + '</span>';
                        }

                        var tooltip = series.Tooltip;

                        var tipText = chartUtils.buildTooltipText(tooltip, accumulator[index], defaultTipText, series.FieldName, series.AggregationType, series.TotalRecords);

                        return tipText;
                    }).attr('value', function (d, i) {
                        var xValue = d[xFieldName];

                        var index = accumulator.map(function (e) {
                            return e[xFieldName];
                        }).indexOf(xValue);
                        if (index < 0) return;

                        return Number(accumulator[index][series.FieldName]).toFixed(2);
                    }).attr('key', function (d) {
                        return d[xFieldName];
                    }).attr('base', function (d, i) {
                        var xValue = d[xFieldName];

                        var index = accumulator.map(function (e) {
                            return e[xFieldName];
                        }).indexOf(xValue);
                        if (index < 0) return valueAxis(0);

                        var base = Number(accumulator[index]['base']);

                        if (minYValue < 0) return valueAxis(base);

                        return valueAxis(base + minYValue);
                    }).attr('id', function (d, i) {
                        return 'Bar' + i;
                    }).attr('seriesidentifier', series.SeriesName).attr('height', function (d, i) {
                        return 0;
                    }).attr('y', function (d, i) {
                        if (groupLengthCheck) {
                            return getBaseAttribute(this);
                        } else {
                            return svgInnerHeight - 1;
                        }
                    }).attr('coord', function (d, i) {
                        var xValue = d[xFieldName];

                        var index = accumulator.map(function (e) {
                            return e[xFieldName];
                        }).indexOf(xValue);
                        if (index < 0) return;

                        var crumb = baseCrumbtFormat;
                        crumb.Name = series.CrumbMetaName;
                        crumb.FieldName = series.CrumbFieldName;
                        crumb.Value = accumulator[index][series.CrumbFieldName];
                        crumb.DisplayFieldName = series.CrumbDisplayFieldName;
                        crumb.DisplayValue = accumulator[index][series.CrumbDisplayFieldName];
                        crumb.DefaultPerspective = defaultPerspective;

                        return JSON.stringify(crumb);
                    }).on("touchstart", function () {
                        columnTooltip.onMouseOver.call(this, parentContainerId);
                    }).on("mouseover", function () {
                        columnTooltip.onMouseOver.call(this, parentContainerId);
                    }).on("mouseout", columnTooltip.onMouseOut).on("touchmove", columnTooltip.onTouchMove).on("mousemove", function () {
                        columnTooltip.onMouseMove.call(this, parentContainerId);
                    }).transition().duration(500).ease(transitionEase).attr('height', function (d, i) {
                        var xValue = d[xFieldName];

                        var index = accumulator.map(function (e) {
                            return e[xFieldName];
                        }).indexOf(xValue);
                        if (index < 0) return 0;

                        var value = Number(accumulator[index][series.FieldName]);

                        var base = Number(accumulator[index]['base']);

                        if (value < 0) return valueAxis(value + base) - valueAxis(base);

                        if (minYValue < 0) return valueAxis(base) - valueAxis(value + base);

                        return valueAxis(base) - valueAxis(value + base - minYValue);
                    }).attr('y', function (d, i) {
                        var xValue = d[xFieldName];

                        var index = accumulator.map(function (e) {
                            return e[xFieldName];
                        }).indexOf(xValue);
                        if (index < 0) return valueAxis(0);

                        var value = Number(accumulator[index][series.FieldName]);
                        var base = Number(accumulator[index]['base']);
                        if (value <= 0) return valueAxis(base);

                        return valueAxis(value + base);
                    });

                    truncateTextByPixel(ContainerId, false);

                    svg.selectAll(".animate").append("animate").attr('attributeType', "XML").attr('attributeName', 'opacity').attr('from', '0.6').attr('to', '0.3').attr('dur', '1s').attr('repeatCount', 'indefinite');

                    if (series.SubSeries != null && series.SubSeries.length > 0) {
                        var baseSeries = series;

                        for (var index1 = 0; index1 < baseSeries.SubSeries.length; index1++) {
                            series = baseSeries.SubSeries[index1];

                            if (series.SeriesType != chartUtils.chartSeriesType.bar) continue;

                            seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                            if (seriesAccumulators[seriesName] == null) continue;

                            var accumulator = seriesAccumulators[seriesName];

                            var displayFormatCurrent = getDisplayFormat(series);
                            var currencySymbolCurrent = getCurrencySymbol(series);
                            var baseFormatCurrent = getBaseFormat(series);

                            group.append('rect').attr('class', function (d) {
                                if (d["className"] == null) return 'bar dataviz editviz ' + series.ClassName;

                                return 'bar dataviz editviz ' + series.ClassName + ' ' + d["className"];
                            }).style('fill', function (d) {
                                if (series.Color != null && series.Color.trim().length > 0) return series.Color;

                                return seriesColor(seriesName);
                            }).style('visibility', function (d) {
                                return series.Hidden ? "hidden" : "visible";
                            }).attr('x', x1(baseSeries.SeriesName)).attr('width', x1.rangeBand()).attr('label', function (d, i) {
                                var tipField = series.TipField == null || series.TipField.trim().length == 0 ? xFieldName : series.TipField;

                                var xValue = d[tipField];

                                var index = accumulator.map(function (e) {
                                    return e[tipField];
                                }).indexOf(xValue);

                                if (index < 0) return;

                                var value = 0;

                                if (accumulator[index] == null) return "--";

                                value = Number(accumulator[index][series.FieldName]);

                                if (isNaN(value)) value = 0;

                                var tipHeader = series.SeriesName;

                                if (series.TipField != null && d[series.TipField] != null) tipHeader = d[series.TipField] + '<br/>' + tipHeader;

                                if (series.ShowDefaultTooltip) {
                                    var defaultTipText = '<span class="tip-header">' + tipHeader + ':</span><span class="tip-value"> ' + chartUtils.format(value, displayFormatCurrent, currencySymbolCurrent, maxValue, baseFormatCurrent, isDecimalPercentNumber) + '</span>';
                                }

                                var tooltip = series.Tooltip;

                                var tipText = chartUtils.buildTooltipText(tooltip, accumulator[index], defaultTipText, series.FieldName, series.AggregationType, series.TotalRecords);

                                return tipText;
                            }).attr('value', function (d, i) {
                                var xValue = d[xFieldName];

                                var index = accumulator.map(function (e) {
                                    return e[xFieldName];
                                }).indexOf(xValue);
                                if (index < 0) return 0;

                                return Number(accumulator[index][series.FieldName]).toFixed(2);
                            }).attr('base', function (d, i) {
                                var xValue = d[xFieldName];

                                var index = accumulator.map(function (e) {
                                    return e[xFieldName];
                                }).indexOf(xValue);
                                if (index < 0) return valueAxis(0);

                                var value = Number(accumulator[index][series.FieldName]);
                                var baseY = Number(accumulator[index][base]);
                                var negativeBaseY = Number(accumulator[index][negativeBase]);

                                if (value < 0) return valueAxis(negativeBaseY);
                                return valueAxis(baseY);
                            }).attr('coord', function (d, i) {
                                var xValue = d[xFieldName];

                                var index = accumulator.map(function (e) {
                                    return e[xFieldName];
                                }).indexOf(xValue);

                                if (index < 0) return;

                                var crumb = baseCrumbtFormat;
                                crumb.Name = series.CrumbMetaName;
                                crumb.FieldName = series.CrumbFieldName;
                                crumb.Value = accumulator[index][series.CrumbFieldName];
                                crumb.DisplayFieldName = series.CrumbDisplayFieldName;
                                crumb.DisplayValue = accumulator[index][series.CrumbDisplayFieldName];
                                crumb.DefaultPerspective = defaultPerspective;

                                return JSON.stringify(crumb);
                            }).attr('seriesidentifier', series.SeriesName).attr('height', function (d, i) {
                                return 0;
                            }).attr('y', function (d, i) {
                                if (groupLengthCheck) {
                                    return getBaseAttribute(this);
                                } else {
                                    return svgInnerHeight - 1;
                                }
                            }).on("touchstart", function () {
                                columnTooltip.onMouseOver.call(this, parentContainerId);
                            }).on("mouseover", function () {
                                columnTooltip.onMouseOver.call(this, parentContainerId);
                            }).on("mouseout", columnTooltip.onMouseOut).on("touchmove", columnTooltip.onTouchMove).on("mousemove", function () {
                                columnTooltip.onMouseMove.call(this, parentContainerId);
                            }).transition().duration(500).ease(transitionEase).attr('y', function (d, i) {
                                var xValue = d[xFieldName];

                                var index = accumulator.map(function (e) {
                                    return e[xFieldName];
                                }).indexOf(xValue);
                                if (index < 0) return y(0);

                                var value = Number(accumulator[index][series.FieldName]);
                                var baseY = Number(accumulator[index][base]);
                                var negativeBaseY = Number(accumulator[index][negativeBase]);
                                if (value <= 0) return isNaN(valueAxis(negativeBaseY)) ? 0 : valueAxis(negativeBaseY);
                                return isNaN(valueAxis(value + baseY)) ? 0 : valueAxis(value + baseY);
                            }).attr('height', function (d, i) {
                                var xValue = d[xFieldName];

                                var index = accumulator.map(function (e) {
                                    return e[xFieldName];
                                }).indexOf(xValue);
                                if (index < 0) return 0;

                                var value = Number(accumulator[index][series.FieldName]);
                                var baseY = Number(accumulator[index][base]);
                                var negativeBaseY = Number(accumulator[index][negativeBase]);
                                if (value < 0) return isNaN(valueAxis(value + negativeBaseY) - valueAxis(negativeBaseY)) ? 0 : valueAxis(value + negativeBaseY) - valueAxis(negativeBaseY);
                                return isNaN(valueAxis(baseY) - valueAxis(value + baseY)) ? 0 : valueAxis(baseY) - valueAxis(value + baseY);
                            });

                            truncateTextByPixel(parentContainerId, false);
                        }

                        if (baseSeries.ShowLabels) showSeriesLabels(baseSeries);
                    }
                    continue;
                }

                var line = d3.svg.line().defined(function (d) {
                    return d;
                }).x(function (d, i) {
                    if (isNaN(x(d[xFieldName]))) return 0;

                    return x(d[xFieldName]) + x.rangeBand() / 2 + chartX;
                }).y(function (d, i) {
                    return valueAxis(Number(d[series.FieldName])) + chartY;
                });

                if (series.SmoothCurves) line = d3.svg.line().defined(function (d) {
                    return d;
                }).interpolate("cardinal").x(function (d, i) {
                    if (isNaN(x(d[xFieldName]))) return 0;

                    return x(d[xFieldName]) + x.rangeBand() / 2 + chartX;
                }).y(function (d, i) {
                    return valueAxis(Number(d[series.FieldName])) + chartY;
                });

                chartContainer.append('path').on("touchstart", function () {
                    var markerElement = getMarkerElement.call(this);
                    markerElement && lineTooltip.onMouseOver.call(markerElement, parentContainerId);
                }).on("mouseover", function () {
                    var markerElement = getMarkerElement.call(this);
                    markerElement && lineTooltip.onMouseOver.call(markerElement, parentContainerId);
                }).on("mouseout", function () {
                    lineTooltip.onMouseOut(seriesConfig);
                }).on("mousemove", function () {
                    var markerElement = getMarkerElement.call(this);
                    markerElement && lineTooltip.onMouseMove.call(markerElement, parentContainerId, seriesConfig);
                }).datum(accumulator).attr('class', function (d) {
                    if (d["className"] == null) return 'line ' + series.ClassName;

                    return 'line ' + series.ClassName + ' ' + d["className"];
                }).style('stroke', function (d) {
                    if (series.Color != null && series.Color.trim().length > 0) return series.Color;

                    return seriesColor(seriesName);
                }).style('stroke-width', function (d, i) {
                    if (series.IsTrendLine) return 3;

                    return 2;
                }).attr('d', line).attr('id', function (d, i) {
                    return 'Line-' + seriesName + i;
                }).attr('seriesidentifier', series.SeriesName).attr('stroke-dasharray', function (d, i) {
                    if (series.IsTrendLine) return '16, 6';
                    var totalLength = getStrokeTotalLength(this);
                    return totalLength + ' ' + totalLength;
                }).attr('stroke-dashoffset', function (d, i) {
                    return getStrokeTotalLength(this);
                }).style('visibility', function (d) {
                    if (series.IsTrendLine) return series.ShowTrendLine ? "visible" : "hidden";
                    return series.Hidden ? "hidden" : "visible";
                }).transition().duration(500).ease(transitionEase).attr('stroke-dashoffset', 0);

                chartContainer.selectAll(".dot " + chartUtils.makeStyleName(seriesName)).data(accumulator.filter(function (d) {
                    return d != null;
                })).enter().append("path").attr('transform', function (d) {
                    return 'translate(' + (x(d[xFieldName]) + x.rangeBand() / 2 + chartX) + ',' + (valueAxis(d[series.FieldName]) + chartY) + ')';
                }).attr('xpos', function (d) {
                    return x(d[xFieldName]) + x.rangeBand() / 2 + chartX;
                }).attr('ypos', function (d) {
                    return valueAxis(d[series.FieldName]) + chartY;
                }).attr('seriesidentifier', series.SeriesName).attr('d', d3.svg.symbol().type('circle').size(lineMarkerSize)).attr('class', function (d) {
                    if (d["className"] == null) return 'dot dataviz editviz ' + chartUtils.makeStyleName(series.ClassName);

                    'dot dataviz editviz ' + chartUtils.makeStyleName(series.ClassName) + ' ' + d["className"];
                }).style("fill", function (d) {
                    var fillColor = seriesColor(seriesName);
                    if (series.Color != null && series.Color.trim().length > 0) fillColor = series.Color;

                    if (series.FormatConfig != null && series.FormatConfig.length > 0) {
                        var displaytext = d[series.FieldName];
                        var formatOption = getFormatOption(series, displaytext, d);
                        if (formatOption != null) {
                            fillColor = formatOption.Fill;
                            this.style.stroke = formatOption.BorderColor;
                            if (formatOption.Animate == true) {
                                this.attributes['class'].value = this.attributes['class'].value + ' animate';
                            }
                        }
                    }
                    return fillColor;
                }).style("stroke", function (d) {
                    if (series.Color != null && series.Color.trim().length > 0) return series.Color;

                    return seriesColor(seriesName);
                }).style('visibility', function (d) {
                    if (series.IsTrendLine) return series.Hidden ? "hidden" : "visible";
                }).attr('label', function (d) {
                    var value = 0;

                    value = Number(d[series.FieldName]);

                    if (isNaN(value)) value = 0;

                    var tipHeader = series.SeriesName;

                    if (series.TipField != null && d[series.TipField] != null) tipHeader = d[series.TipField] + '<br/>' + tipHeader;

                    if (series.ShowDefaultTooltip) {
                        var defaultTipText = '<span class="tip-header">' + tipHeader + ':</span><span class="tip-value"> ' + chartUtils.format(value, displayFormatCurrent, currencySymbolCurrent, maxValue, baseFormatCurrent, isDecimalPercentNumber) + '</span>';
                    }

                    var tooltip = series.Tooltip;

                    var tipText = chartUtils.buildTooltipText(tooltip, d, defaultTipText, series.FieldName, series.AggregationType, series.TotalRecords);

                    return tipText;
                }).attr('value', function (d) {
                    return Number(d[series.FieldName]).toFixed(2);
                }).attr('id', function (d, i) {
                    return 'Dot-' + seriesName + i;
                }).style('opacity', function () {
                    if (series.ShowLineMarkers) return 1;
                    return 0;
                }).attr('coord', function (d, i) {
                    var crumb = baseCrumbtFormat;
                    crumb.Name = series.CrumbMetaName;
                    crumb.FieldName = series.CrumbFieldName;
                    crumb.Value = d[series.CrumbFieldName];
                    crumb.DisplayFieldName = series.CrumbDisplayFieldName;
                    crumb.DisplayValue = d[series.CrumbDisplayFieldName];
                    crumb.DefaultPerspective = defaultPerspective;
                    return JSON.stringify(crumb);
                }).on("touchstart", function () {
                    lineTooltip.onMouseOver.call(this, parentContainerId);
                }).on("mouseover", function () {
                    lineTooltip.onMouseOver.call(this, parentContainerId);
                }).on("mouseout", function () {
                    lineTooltip.onMouseOut.call(this, seriesConfig);
                }).on("mousemove", function () {
                    lineTooltip.onMouseMove.call(this, parentContainerId, seriesConfig);
                });

                for (var _index = 0; _index < seriesConfig.length; _index++) {
                    drawMarkerLines(seriesConfig[_index]);
                }

                svg.selectAll(".animate").append("animate").attr('attributeType', "XML").attr('attributeName', 'opacity').attr('from', '0.8').attr('to', '0.4').attr('dur', '1s').attr('repeatCount', 'indefinite');

                var translateCoordinateString = svg.select('.y').attr('transform').substring(10);
                var translateCoordinate = translateCoordinateString.substring(0, translateCoordinateString.length - 1).split(',');
                var getBoundingClientRect = svg.select('g')[0] && svg.select('g')[0][0] ? svg.select('g')[0][0].getBoundingClientRect() : {};
                var _rectWidth = getBoundingClientRect.width - svg.select('.y')[0][0].getBoundingClientRect().width;
                var _rectHeight = getBoundingClientRect.height - svg.select('.x')[0][0].getBoundingClientRect().height;
                var translateWidth = parseInt(translateCoordinate[0]);
                var translateHeight = parseInt(translateCoordinate[1]);
                if (index === 0) {
                    svg.select('g').select('rect').attr('transform', 'translate(' + translateWidth + ',' + translateHeight + ')').attr('width', _rectWidth).attr('height', _rectHeight).on("touchstart", function () {
                        var markerElement = getMarkerElement.call(this);
                        markerElement && lineTooltip.onMouseOver.call(markerElement, parentContainerId);
                    }).on("mouseover", function () {
                        var markerElement = getMarkerElement.call(this);
                        markerElement && lineTooltip.onMouseOver.call(markerElement, parentContainerId);
                    }).on("mouseout", function () {
                        lineTooltip.onMouseOut(seriesConfig);
                    }).on("mousemove", function () {
                        var markerElement = getMarkerElement.call(this);
                        markerElement && lineTooltip.onMouseMove.call(markerElement, parentContainerId, seriesConfig);
                    });
                    // Adding events on rect element if chart contains combination of bar and line series
                } else if (index !== 0 && chartSeriesTypeSet.size === 2) {
                    svg.select('g').select('rect').attr('transform', 'translate(' + translateWidth + ',' + translateHeight + ')').attr('width', _rectWidth).attr('height', _rectHeight).on("touchstart", function () {
                        var markerElement = getMarkerElement.call(this);
                        markerElement && lineTooltip.onMouseOver.call(markerElement, parentContainerId);
                        markerElement && columnTooltip.onMouseOver.call(markerElement, parentContainerId);
                    }).on("mouseover", function () {
                        var markerElement = getMarkerElement.call(this);
                        markerElement && lineTooltip.onMouseOver.call(markerElement, parentContainerId);
                        markerElement && columnTooltip.onMouseOver.call(markerElement, parentContainerId);
                    }).on("mouseout", function () {
                        lineTooltip.onMouseOut(seriesConfig);
                        columnTooltip.onMouseOut(this);
                    }).on("mousemove", function () {
                        var markerElement = getMarkerElement.call(this);
                        markerElement && lineTooltip.onMouseMove.call(markerElement, parentContainerId, seriesConfig);
                    });
                }
            }
        }

        if (showLegend) {
            var legendItems = [];
            var legendItem = {};

            for (var i = 0; i < seriesConfig.length; i++) {
                var series = seriesConfig[i];

                if (series.IsTrendLine) continue;

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                legendItem = chartUtils.findValue(legendItems, 'SeriesName', seriesName);
                if (legendItem != null) continue;

                legendItem = {};
                legendItem['SeriesCode'] = seriesName;
                seriesName = "SeriesName";

                legendItem[seriesName] = series.SeriesName;
                legendItem['ClassName'] = series.ClassName;
                legendItem['SeriesNameValue'] = series.SeriesName;
                legendItem['Color'] = series.Color;
                legendItems.push(legendItem);

                if (series.SubSeries != null) {
                    for (var index = 0; index < series.SubSeries.length; index++) {
                        legendItem = {};
                        seriesName = chartUtils.replaceAll(series.SubSeries[index].SeriesName, ' ', '');
                        legendItem['SeriesCode'] = seriesName;
                        seriesName = "SeriesName";

                        legendItem[seriesName] = series.SubSeries[index].SeriesName;
                        legendItem['ClassName'] = series.SubSeries[index].ClassName;
                        legendItem['SeriesNameValue'] = series.SubSeries[index].SeriesName;
                        legendItem['Color'] = series.SubSeries[index].Color;
                        legendItems.push(legendItem);
                    }
                }
            }

            if (series.StackOnField != null || series.GroupOnField != null) {

                if (seriesName.toLocaleLowerCase().indexOf('month') >= 0) {
                    chartUtils.sort(legendItems, seriesName);
                } else if (seriesName.toLocaleLowerCase().indexOf('day') >= 0) {
                    chartUtils.sort(legendItems, seriesName);
                } else {
                    legendItems.sort(function (a, b) {
                        return a.SeriesNameValue > b.SeriesNameValue ? 1 : b.SeriesNameValue > a.SeriesNameValue ? -1 : 0;
                    });
                }
            }

            var legendHeight = Number(legendItems.length) * Number(legendRectSize) + Number(legendSpacing) + Number(offset);

            legendHeight = chartUtils.makeRelative(legendHeight, height);
            legendRectSize = chartUtils.makeRelative(legendRectSize, Math.min(width, height));
            legendSpacing = chartUtils.makeRelative(legendSpacing, height);
            offset = chartUtils.makeRelative(offset, height);

            if (legendLocation == chartUtils.legendLocation.left || legendLocation == chartUtils.legendLocation.right) legendY = chartHeight / 2 - legendHeight / 2 + chartY;

            var legendCount = legendItems.length;
            var legendCountInOneLine = Math.ceil(legendCount / legendLineCount);
            var legendSectionWidth = (width - Number(chartX) - margin.right * width) / legendCountInOneLine;
            var currentLegendLine = 0;

            var legendContainer = svg.append('g');
            legendContainer.attr('transform', 'translate(' + legendX + ',' + legendY + ')');

            var legend = legendContainer.selectAll(".legend").data(legendItems).enter().append("g").attr("class", function (d) {
                return 'legend ' + d['SeriesCode'];
            }).attr("transform", function (d, i) {
                var itemHeight = Number(legendRectSize) + Number(legendSpacing);
                var horz = 0;
                var vert = i * (Number(itemHeight) + Number(offset));

                if (legendLocation == chartUtils.legendLocation.top || legendLocation == chartUtils.legendLocation.bottom) {
                    horz = i % legendCountInOneLine * Number(legendSectionWidth) + Number(legendSpacing) + Number(chartX);
                    vert = Math.floor(i / legendCountInOneLine) * (Number(legendRectSize) + Number(legendSpacing) + Number(offset));
                }

                return "translate(" + horz + "," + vert + ")";
            });

            legend.append('rect').attr('width', legendRectSize).attr('height', legendRectSize).attr('class', function (d) {
                return 'legend ' + d['ClassName'];
            }).attr('label', function (d) {
                return d[seriesName];
            }).style('fill', function (d) {
                if (d.Color != null && d.Color.trim().length > 0) return d.Color;

                return seriesColor(d['SeriesCode']);
            });

            legend.append("text").attr("x", Number(legendRectSize) + Number(legendSpacing)).attr("y", legendRectSize / 2).style('text-anchor', 'start').style('opacity', function (d) {
                return series.Hidden ? 0.5 : 1;
            }).style('dominant-baseline', 'central').text(function (d) {
                return d[seriesName];
            });
        }

        if (stampText != null && stampText.trim().length > 0) {
            var stampTextContainer = svg.append('g');

            var rectWidth = width / 1.5;
            var rectHeight = 80;

            stampTextContainer.append("foreignObject").attr("x", 0).attr("y", 0).attr("width", rectWidth).attr("height", rectHeight).append("xhtml:body").html("<p class='stampText'>" + stampText + "</p>");
        }

        if (showDataLegend) {
            var tableContainer = window.document.createElement("div");
            tableContainer.setAttribute("class", "legend-table");
            tableContainer.setAttribute("style", "width:100%;height:" + legendTableHeight + "px;overflow:auto;display:block;position:relative;bottom:0");

            el.appendChild(tableContainer);

            var table = window.document.createElement("table");
            table.setAttribute("style", "table-layout: fixed;width:100%;");

            tableContainer.appendChild(table);

            var tbody = window.document.createElement("tbody");
            table.appendChild(tbody);

            if (includeTotal) {
                for (var index = 0; index < seriesConfig.length; index++) {
                    var series = seriesConfig[index];
                    var accumulator = seriesAccumulators[series.SeriesName];

                    if (accumulator == null) continue;

                    var tr = window.document.createElement("tr");
                    var td = window.document.createElement("td");
                    td.setAttribute("class", "row-header " + series.ClassName);

                    td.innerHTML = series.SeriesName;

                    tr.appendChild(td);

                    tbody.appendChild(tr);

                    for (var i = 0; i < accumulator.length; i++) {
                        var d = accumulator[i];
                        var td = window.document.createElement("td");
                        td.innerHTML = d[series.FieldName];

                        tr.appendChild(td);
                    }
                }
            } else {
                var thead = window.document.createElement("thead");

                for (var index = 0; index < seriesConfig.length; index++) {
                    var series = seriesConfig[index];
                    var accumulator = seriesAccumulators[series.SeriesName];

                    if (accumulator == null) continue;

                    var th = window.document.createElement("th");
                    th.setAttribute("class", "column-header");

                    th.innerHTML = series.SeriesName;

                    thead.appendChild(th);
                }

                tbody.appendChild(thead);

                var tr = window.document.createElement("tr");

                for (var index = 0; index < seriesConfig.length; index++) {
                    var series = seriesConfig[index];
                    var accumulator = seriesAccumulators[series.SeriesName];

                    if (accumulator == null) continue;

                    var d = chartUtils.findValue(accumulator, xFieldName, "Total");
                    var td = window.document.createElement("td");
                    td.innerHTML = d[series.FieldName];

                    tr.appendChild(td);
                }

                tbody.appendChild(tr);
            }
        }

        function getFormatOption(series, value, d) {
            var conditionalFormats = series.FormatConfig;
            for (var cf = 0; cf < conditionalFormats.length; cf++) {
                var conditionalFormat = conditionalFormats[cf];
                var displayText = value == "" || value == null ? NaN : value;
                if (conditionalFormat.TableField != "--" && conditionalFormat.TableField != null) displayText = d[conditionalFormat.TableField] == null ? NaN : d[conditionalFormat.TableField];

                if (conditionalFormat.TargetProperty != null && conditionalFormat.TargetProperty != "--") {
                    if (d[conditionalFormat.TargetProperty] != null) conditionalFormat.FormatValue = d[conditionalFormat.TargetProperty];
                }
                var expression = chartUtils.buildFormatExpression(conditionalFormat, displayText);
                try {
                    if (eval(expression)) {
                        if (conditionalFormat.FormatOption != null) {
                            return conditionalFormat.FormatOption[0];
                        }
                    }
                } catch (ex) {
                    //Ignore exception & continue to next cell.
                }
            }
        }

        function sort(accumulator) {
            if (sortData != null && sortKeyName != null && sortValueName == null) {
                var temp = [];

                for (var i = 0; i < accumulator.length; i++) {
                    temp.push(accumulator[i]);
                }accumulator.length = 0;

                for (var index = 0; index < sortData.length; index++) {
                    var sortKey = sortData[index][sortKeyName];

                    var value = chartUtils.findValue(temp, xFieldName, sortKey);

                    if (value == null) continue;

                    accumulator.push(value);
                }
                return;
            }

            if (!sortAxis) sortAxis = chartUtils.isSpecialSort(xFieldName);

            if (sortAxis) chartUtils.sort(accumulator, xFieldName, null, inverseSort);else chartUtils.sort(accumulator, base, null, inverseSort, null, true);
        };
    };

    // Initiate rendering for a widget
    var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
        // Get widget specific widgetConfig
        var widgetConfig = columnChartConfigBuilder.configBuilder(cloneDeep(configObj));
        renderWidget(widgetConfig);
    };

    return {
        renderWidget: renderWidget,
        initiateWidgetRendering: initiateWidgetRendering
    };
};

export default columnChart();